import { computed, ref, unref } from 'vue';
import SalesTransactionPartiesAPI from 'dashboard/api/salesTransactionParties';

const values = (source, key) => {
  const value = source?.[key];
  return Array.isArray(value) ? value : [];
};

export function useSalesPartyCatalog({ transactionId, t, notify }) {
  const catalog = ref({});
  const loading = ref(false);

  const originOptions = computed(() => values(catalog.value, 'lista_origem'));
  const contactOptions = computed(() => values(catalog.value, 'lista_contato'));
  const documentTypes = computed(() => values(catalog.value, 'tipodocumentos'));

  const load = async () => {
    if (!unref(transactionId)) return catalog.value;
    loading.value = true;
    try {
      const response = await SalesTransactionPartiesAPI.catalog(
        unref(transactionId)
      );
      catalog.value = response?.data?.data || {};
      return catalog.value;
    } catch (error) {
      notify(t('SALES_PARTIES.CATALOG.LOAD_ERROR'));
      return {};
    } finally {
      loading.value = false;
    }
  };

  return { contactOptions, documentTypes, load, loading, originOptions };
}
